import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ProjectCard } from './ProjectCard';
interface Project {
  id?: string;
  title: string;
  category: string;
  year: string;
  image: string;
  height?: string;
  description?: string;
}
interface MasonryGridProps {
  projects: Project[];
  onProjectClick?: (project: Project) => void;
}
export function MasonryGrid({
  projects,
  onProjectClick
}: MasonryGridProps) {
  const [columnCount, setColumnCount] = useState(3);
  const containerRef = useRef<HTMLDivElement>(null);
  // Detect screen size and set column count
  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth < 768) {
        setColumnCount(1);
      } else if (window.innerWidth < 1024) {
        setColumnCount(2);
      } else {
        setColumnCount(3);
      }
    };
    updateColumns();
    window.addEventListener('resize', updateColumns);
    return () => window.removeEventListener('resize', updateColumns);
  }, []);
  // Distribute projects into columns (Tetris-style)
  const columns: Project[][] = Array.from({
    length: columnCount
  }, () => []);
  const columnHeights = Array(columnCount).fill(0);
  projects.forEach(project => {
    // Find the shortest column
    const shortestColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
    columns[shortestColumnIndex].push(project);
    // Estimate height (you can adjust these values based on your needs)
    columnHeights[shortestColumnIndex] += 1;
  });
  return <div ref={containerRef} className="flex gap-8" data-id="element-140">
      {columns.map((column, columnIndex) => <div key={columnIndex} className="flex-1 space-y-8" data-id="element-141">
          <AnimatePresence data-id="element-142">
            {column.map((project, index) => <motion.div key={project.id || project.title} layout initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9
        }} transition={{
          duration: 0.6,
          delay: index * 0.05
        }} onClick={() => onProjectClick?.(project)} data-id="element-143">
                <ProjectCard index={columnIndex * column.length + index} {...project} data-id="element-144" />
              </motion.div>)}
          </AnimatePresence>
        </div>)}
    </div>;
}